import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class RegisterAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'System';
  controllerName = 'Registers';
  /**
   * Tạo mới dữ liệu
   */
  createDatabase(model) {
    let tenantId = model.tenant_id; // Lấy tenantId từ model
    let url = window._apis.ProxyForwarder + '/' + this.controllerName;
    let request = {
      url: [url, 'database'].join('/')+ `?tenantId=${tenantId}&app=v1`,
      data: model,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu sao lưu
   */
  getBackupDatabase(model) {
    let request = {
      url: [this.getAPIUrl(), 'list'].join('/'),
      data: model,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu sao lưu
   */
  getBusyDatabase(model) {
    let request = {
      url: [this.getAPIUrl(), 'busy'].join('/'),
      data: model,
    };

    return httpClient.postAsync(request);
  }

  /**
   * sao lưu dữ liệu
   */
  backup(model) {
    let request = {
      url: [this.getAPIUrl(), 'backup'].join('/'),
      data: model,
    };

    return httpClient.postAsync(request);
  }

  /**
   * sao lưu dữ liệu
   */
  cancelBackup(model) {
    let request = {
      url: [this.getAPIUrl(), 'cancelbackup'].join('/'),
      data: model,
    };

    return httpClient.postAsync(request);
  }

  /**
   * phục hồi dữ liệu
   */
  restore(model) {
    let request = {
      url: [this.getAPIUrl(), 'restore'].join('/'),
      data: model,
    };

    return httpClient.postAsync(request);
  }

  /**
   * sao lưu dữ liệu
   */
  databaseHistory(model) {
    let request = {
      url: [this.getAPIUrl(), 'history'].join('/'),
      data: model,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Đăng ký thông tin đơn vị và Tạo mới dữ liệu
   */
  createTenant(model) {
    let tenantId = model.tenant_id; // Lấy tenantId từ model
    let url = window._apis.ProxyForwarder + '/' + this.controllerName;
    let request = {
      url: [url, 'tenant'].join('/')+ `?tenantId=${tenantId}&app=v1`,
      data: model,
    };

    return httpClient.postAsync(request);
  }

    /**
   * Đăng ký thông tin đơn vị và Tạo mới dữ liệu v3
   */
    createTenantV3(model) {
    let tenantId = model.tenant_id; // Lấy tenantId từ model
    let url = window._apis.ProxyForwarder + '/' + this.controllerName;
    let request = {
      url: [url, 'tenant'].join('/')+ `?tenantId=${tenantId}&app=v3`,
      data: model,
    };

    return httpClient.postAsync(request);
    }

  updateLastActive(param) {
    let request = {
      url: [this.getAPIUrl(), 'update-last-active'].join('/'),
      data: param,
    };

    return httpClient.postAsync(request);
  }

  async showStep(payload) {
    let request = {
      url: this.getAPIUrl() + '/autoshow',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }

  async updateShowStep(payload) {
    let request = {
      url: this.getAPIUrl() + '/updateautoshow',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }

  /**
   * tạo mới database v2
   * VQDUC 02.08.2023
   * @param {*} model 
   * @returns 
   */
  async createDatabaseV3(model){
    let tenantId = model.tenant_id; // Lấy tenantId từ model
    let url = window._apis.ProxyForwarder + '/' + this.controllerName;
    let request = {
      url: [url, 'database'].join('/')+ `?tenantId=${tenantId}&app=v3`,
      data: model,
    };

    return httpClient.postAsync(request);
  }
}

export default new RegisterAPI();
